import { createContext, useMemo, useState } from 'react';

/**
 * On pages with many studio cards (e.g. search), the browser competes on image downloads.
 * When the user interacts with one carousel, we set that studio id so its images use
 * stronger fetch priority; other cards stay on low priority until another carousel is used.
 */
export const CarouselSearchPriorityContext = createContext(null);

export function CarouselSearchPriorityProvider({ children }) {
  const [activeStudioId, setActiveStudioId] = useState(null);

  const value = useMemo(
    () => ({ activeStudioId, setActiveStudioId }),
    [activeStudioId]
  );

  return (
    <CarouselSearchPriorityContext.Provider value={value}>
      {children}
    </CarouselSearchPriorityContext.Provider>
  );
}
